import { StateType } from './types';

function setLoading(state: StateType, loading: boolean) {
  state.loading = loading;
}

export default {
  setLoading,
};
